import MyAccountDetails from "e.sic-platform.webclient/src/pages/my-account/my-account-details/MyAccountDetails";
import MyAccountActions from 'e.sic-platform.webclient/src/pages/my-account/my-account-details/MyAccountDetailsActions';
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { CurrentUserProfileStorageModel } from "e.sic-platform.webclient/src/services/user/CurrentUserProfileStorage";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";

export default observer(function MyAccountPage() {
    const [currentUserProfileStorage] = useState(
        CurrentUserProfileStorageModel.create({}, {api})
    );

    const [edit, setEdit] = useState(false);

    return (
        <>
            {!edit && <MyAccountActions onEdit={() => setEdit(!edit)}/>}
            <MyAccountDetails currentUserProfileStorage={currentUserProfileStorage} edit={edit} onEditCancel={() => setEdit(!edit)} withAddress/>
        </>
    )
})